export interface IConfig {
	AZURE_AD_CLIENT_ID: string | undefined;
	AZURE_AD_TENANT_ID: string | undefined;
	REDIRECT_URI: string | undefined;
	SCOPES: string | undefined;
	APPINSIGHTS_CONNECTION_STRING: string | undefined;
	API_BASE_URL: string | undefined;
	/**
	 * Origin of the client (tenant) app, used for the
	 * `?impersonate={clientId}&returnTo=` deep links ("Open client app as
	 * this tenant"). `REACT_APP_CLIENT_APP_URL`; derived from the admin
	 * hostname when unset (see `defaultClientAppUrl`).
	 */
	CLIENT_APP_URL: string;
}

/**
 * Client app origin when REACT_APP_CLIENT_APP_URL is not set: the local
 * client dev server (inspect-frontend-client serves `https://localhost:3030`)
 * when this app runs on localhost, otherwise the `app.` host of the same
 * environment as the admin host (`*.dev.inspecttec.com` →
 * `app.dev.inspecttec.com`, `*.qa.inspecttec.com` → `app.qa.inspecttec.com`,
 * anything else → production `app.inspecttec.com`).
 */
function defaultClientAppUrl(): string {
	if (typeof window === "undefined") return "https://app.inspecttec.com";
	const host = window.location.hostname.toLowerCase();
	if (host === "localhost" || host === "127.0.0.1") {
		return "https://localhost:3030";
	}
	const env = host.match(/\.(dev|qa)\.inspecttec\.com$/)?.[1];
	return env
		? `https://app.${env}.inspecttec.com`
		: "https://app.inspecttec.com";
}

const Config: IConfig = {
	AZURE_AD_CLIENT_ID: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
	AZURE_AD_TENANT_ID: process.env.REACT_APP_AZURE_AD_TENANT_ID,
	REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI,
	SCOPES: process.env.REACT_APP_SCOPES,
	APPINSIGHTS_CONNECTION_STRING:
		process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
	API_BASE_URL:
		process.env.REACT_APP_API_BASE_URL || "http://localhost:7091/api",
	CLIENT_APP_URL:
		process.env.REACT_APP_CLIENT_APP_URL || defaultClientAppUrl(),
};

export default Config;
